import { VALIDATE_CODES } from './codes';
export var regexp = function (regexpValue, errorText) {
    return function (value, values, texts) {
        var isValid = false;
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            isValid = regexpValue.test(String(value));
        }
        return isValid ? '' : errorText || texts[VALIDATE_CODES.default];
    };
};
//# sourceMappingURL=regexp.js.map